export type City = {
  city_name: string;
  publishedAt?: string;
};

export type State = {
  state_name: string;
  cities: City[];
};

export type Country = {
  country_name: string;
  country_url: string; // Made country_url mandatory
  states: State[];
};

export type SearchResult = {
  type: "country" | "state" | "city";
  country_name?: string | null;
  country_url?: string | null;
  state_name?: string | null;
  state_url?: string | null;
  city_name?: string | null;
  city_url?: string | null;
};

export function searchLocationWithData(
  searchVariable: string,
  data: any
): SearchResult | null {
  let cityMatch: SearchResult | null = null;
  let stateMatch: SearchResult | null = null;
  let countryMatch: SearchResult | null = null;

  for (const country of data) {
    // Search by country_url instead of country_name

    if (
      country?.country_url?.toLowerCase()?.trim() ===
      `study-in-${searchVariable?.toLowerCase()?.trim()}`
    ) {
      countryMatch = {
        type: "country",
        country_url: country?.country_url,
        country_name: country?.country_name, // Still return country_name for reference
      };
    }

    for (const state of country?.states ?? []) {
      if (
        state?.state_url?.toLowerCase()?.trim() ===
        searchVariable?.toLowerCase()?.trim()
      ) {
        stateMatch = {
          type: "state",
          state_name: state?.state_name,
          state_url: state?.state_url,
          country_name: country?.country_name,
          country_url: country?.country_url,
        };
      }

      for (const city of state?.cities ?? []) {
        if (
          city?.city_url?.toLowerCase()?.trim() ===
          searchVariable?.toLowerCase()?.trim()
        ) {
          cityMatch = {
            type: "city",
            city_name: city?.city_name,
            city_url: city?.city_url,
            state_name: state?.state_name,
            state_url: state?.state_url,
            country_name: country?.country_name,
            country_url: country?.country_url,
          };
        }
      }
    }
  }

  return cityMatch || stateMatch || countryMatch || null;
}
